import { render, staticRenderFns } from "./UnionReverse.vue?vue&type=template&id=5463bd63"
import script from "./UnionReverse.vue?vue&type=script&lang=js"
export * from "./UnionReverse.vue?vue&type=script&lang=js"
import style0 from "./UnionReverse.vue?vue&type=style&index=0&id=5463bd63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports